module.exports = "/_next/static/images/b542cd8fa471a236c7e62369efbe4f15-features-lg.png";